import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { BusinessCheckerKeysEnum } from '@zaoblako/shared/modules/business/enum/business-checker-keys.enum';
import type { MasterMilestoneFindInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find.dto';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { UnitFindInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-find.dto';
import type { FilialFindInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';

import * as yup from 'yup';

/** Sub-project default values created and update requests body - DTO signature */
export interface SubprojectDefaultsFormInterface {
  /** Default subproject master milestone */
  masterMilestone?: MasterMilestoneFindInterface;
  /** Default subproject direction */
  direction?: DirectionFindInterface;
  /** Default subproject unit */
  unit?: UnitFindInterface;
  /** Default subproject filial */
  filial?: FilialFindInterface;
  /** Default subproject client */
  client?: ClientFindInterface;
  /** Default subproject user auditors */
  userAuditors?: UserFindInterface[];
  /** Default subproject group auditors */
  userGroupAuditors?: UserGroupFindInterface[];
  /** Default subproject deals */
  deals?: DealFindInterface[];
}

/** Sub-project default values created and update requests body - DTO schema */
export const SubprojectDefaultsFormDto = SerdeDtoClass.create<SubprojectDefaultsFormInterface>(ProjectDtoKeysEnum.SUBPROJECT_DEFAULTS_FORM_DTO, {
  masterMilestone: {
    optional: true,
    label: 'Мастер-веха',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.MASTER_MILESTONE_ASSERT_EXISTS_BY_DTO],
  },
  direction: {
    optional: true,
    label: 'БС',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO],
  },
  unit: {
    optional: true,
    label: 'БС',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.UNIT_ASSERT_EXISTS_BY_DTO],
  },
  filial: {
    optional: true,
    label: 'Филиал',
    serializer: entityLikeSchema,
    checkers: [CatalogCheckersEnum.FILIAL_ASSERT_EXISTS_BY_DTO],
  },
  client: {
    optional: true,
    label: 'Клиент',
    serializer: entityLikeSchema,
    checkers: [ClientCheckerKeysEnum.CLIENT_ASSERT_EXISTS_BY_DTO],
  },
  userAuditors: {
    optional: true,
    label: 'Пользователи-аудиторы',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
  },
  userGroupAuditors: {
    optional: true,
    label: 'Группы-аудиторы',
    serializer: yup.array(entityLikeSchema),
    checkers: [SecurityBackendValidatorsEnum.USER_GROUP_ASSERT_EXISTS_BY_DTO],
  },
  deals: {
    optional: true,
    label: 'Сделки',
    serializer: yup.array(entityLikeSchema),
    checkers: [BusinessCheckerKeysEnum.DEAL_ASSERT_EXISTS_BY_DTO],
  },
});
